import { ABTestingState } from './types'
import ABTestCampaigns from '~/entities/ABTestCampaigns'

export const state: ABTestingState = {
  visitorId: null,
  campaigns: new ABTestCampaigns(),
  loading: true,
  errors: [],
}
